import { PopoverProps } from 'antd';
import React from 'react';
import { TwitterPicker, TwitterPickerProps } from 'react-color';
import { useInputController } from '../../hooks/useInputController';
import { useFormItemEnabled } from '../../item/useFormItemEnabled';
import { ColorInputPopover } from './style/ColorInputPopover';

// 18 colori predefiniti per il picker [18 è importante]
// verificati AA compliant per testo su fondo bianco
const colors = [
  '#E03400',
  '#A51309',
  '#E3165B',
  '#9c27b0',
  '#673ab7',
  '#3f51b5',
  '#0B78D0',
  '#027DB6',
  '#007E8F',
  '#008577',
  '#3A833C',
  '#5A822B',
  '#707A15',
  '#857700',
  '#946F00',
  '#A86500',
  '#795548',
  '#607d8b',
];

// TODO verificare i colori in base all'accessibilità
const colorsNotSafe = [
  '#ff5722',
  '#f44336',
  '#e91e63',
  '#9c27b0',
  '#673ab7',
  '#3f51b5',
  '#2196f3',
  '#03a9f4',
  '#00bcd4',
  '#009688',
  '#4caf50',
  '#8bc34a',
  '#cddc39',
  '#ffeb3b',
  '#ffc107',
  '#ff9800',
  '#795548',
  '#607d8b',
];
export interface IColorInputProps extends Omit<TwitterPickerProps, 'name'> {
  name: string;
  defaultColor?: string;
  popoverProps?: Omit<PopoverProps, 'title' | 'content' | 'children'>;
}

export function ColorInput(props: IColorInputProps) {
  const { name, defaultColor, ...inputProps } = props;

  const { enabled } = useFormItemEnabled();

  const {
    field: { value, onChange, onBlur, ref },
  } = useInputController(name, { enabled });

  return (
    <ColorInputPopover
      color={value ?? defaultColor}
      picker={
        <TwitterPicker
          {...inputProps}
          ref={ref}
          color={value ?? defaultColor}
          onChange={e => {
            onChange(e.hex);
          }}
          triangle="hide"
          width="396px"
          colors={colors}
          className="color-picker"
        />
      }
    />
  );
}
